import { render, staticRenderFns } from "./AchievementComp.vue?vue&type=template&id=02001377&scoped=true&"
import script from "./AchievementComp.vue?vue&type=script&lang=js&"
export * from "./AchievementComp.vue?vue&type=script&lang=js&"
import style0 from "./AchievementComp.vue?vue&type=style&index=0&id=02001377&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02001377",
  null
  
)

export default component.exports